import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b733914"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  class: "btn-group btn-group-sm",
  role: "group",
  "aria-label": "Responsibility"
}
const _hoisted_3 = ["onClick", "title", "innerHTML"]

import { computed, inject } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import _get from 'lodash/get';
import { Report } from '@/models';
import { ReportsState } from '@/store/reports/types';

interface IResponsibilityOption {
  code: string;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConditionResponsibilities',
  props: {
    notePath: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const actProperty: any = inject('actProperty');

// Interface for responsibility options
const options: IResponsibilityOption[] = [
  { code: 'TT',   name: 'Tenant' },
  { code: 'STTA', name: 'Subject To Tenancy Agreement' },
  { code: 'CLN',  name: 'Cleaning' },
  { code: 'FWT',  name: 'Fair Wear and Tear' },
  { code: 'CLR',  name: 'Clarify' },
  { code: 'INF',  name: 'Information Only' },
  // { code: 'LL',   name: 'Landlord' },
];

const reportsState = computed(() => store.state.reports as ReportsState);

const note = computed(() => _get(reportsState.value.current, props.notePath));
const responsibility = computed({
  get: () => _get(note.value, 'responsibility', []),
  set: (data: string[]) => {
    setReportDeep({
      path: `${props.notePath}.responsibility`,
      data
    });
  }
});

// Methods converted to regular functions
const setReport = async (report: Report) => {
  await store.dispatch('reports/setReport', report);
};

const setReportDeep = async (payload: {path: string, data: any}) => {
  await store.dispatch('reports/setReportDeep', payload);
};

const responsibilitySelectedClassName = (option: IResponsibilityOption) => {
  let className = `btn btn-${option.code.toLowerCase()} `;

  if (responsibility.value === undefined) {
    return className;
  }

  if (Array.isArray(responsibility.value)) {
    className += responsibility.value.includes(option.code.toUpperCase()) ? 'selected' : '';
  } else {
    actProperty.displayError(Error(`The Note Responsibility is not an array: ${JSON.stringify(responsibility.value)}`));
  }

  return className;
};

const setResponsibility = (option: IResponsibilityOption) => {
  // make a copy so we can replace the old array
  const data = (responsibility.value === undefined) ? [] : [...responsibility.value];

  const foundIndex = data.indexOf(option.code);

  if (foundIndex > -1) {
    data.splice(foundIndex, 1);
  } else {
    data.push(option.code);
  }

  responsibility.value = data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
        return _createElementVNode("button", {
          key: option.code,
          type: "button",
          onClick: ($event: any) => (setResponsibility(option)),
          class: _normalizeClass(responsibilitySelectedClassName(option)),
          title: option.name,
          innerHTML: option.code
        }, null, 10, _hoisted_3)
      }), 64))
    ])
  ]))
}
}

})